import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { SERVICE_TIME_ZONE_OFFSET } from '@app/@shared/utils/service-time-zone';
import { getServiceUtcOffsetLabel } from '@app/@shared/utils/utc-offset.util';

/**
 * UTC offset label (e.g. "UTC+3") for service-slot times. Uses the brand-level
 * fixed service offset when configured, otherwise the offset of `value`.
 */
@Pipe({
  name: 'serviceUtcOffsetLabel',
  standalone: false,
})
export class ServiceUtcOffsetLabelPipe implements PipeTransform {
  constructor(
    @Optional()
    @Inject(SERVICE_TIME_ZONE_OFFSET)
    private serviceTimeZoneOffset?: string | null,
  ) {}

  transform(value: string | null | undefined): string | null {
    return getServiceUtcOffsetLabel(value, this.serviceTimeZoneOffset);
  }
}
